import { useSelector } from 'src/store';
import { selectors } from 'src/store/navbar';
import { useInlineFilterButtonsDockedStates } from './useInlineFilterButtons';

export const useNavbarState = () => {
  const state = useSelector((state) => ({
    animationsIsShowing: selectors.selectAnimations(state),
    backButtonIsShowing: selectors.selectBackButton(state),
    cuisineFiltersIsShowing: selectors.selectCuisineFilters(state),
    datePickerIsShowing: selectors.selectDatePicker(state),
    dietaryFiltersIsShowing: selectors.selectDietaryFilters(state),
    filterBarIsShowing: selectors.selectFilterBar(state),
    isContentShowing: selectors.selectIsContentShowing(state),
    isScrollingUp: selectors.selectIsScrollingUp(state),
    menuBarIsShowing: selectors.selectMenuBar(state),
    moreFiltersIsShowing: selectors.selectMoreFilters(state),
    navigationIsShowing: selectors.selectNavigation(state),
    promoIsShowing: selectors.selectPromo(state),
    proteinFiltersIsShowing: selectors.selectProteinFilters(state),
    searchIsShowing: selectors.selectSearch(state),
    subCuisineFiltersIsShowing: selectors.selectSubCuisineFilters(state),
  }));
  const inlineFilterButtons = useInlineFilterButtonsDockedStates();
  return { ...state, inlineFilterButtons };
};
